var enUSTranslations = {
  "ActionToolbar.itemButton": "Action button",
  "ActionToolbar.moreActions": "More actions",
  "AvatarCluster.clusterLabel": "Group of user avatars",
  "AvatarCluster.defaultTooltipContent": "Includes {{firstUser}}, {{secondUser}}, and {{thirdUser}}",
  "AvatarCluster.tooltipContentForSingleUser": "Includes {{user}}",
  "AvatarCluster.tooltipContentForTwoUsers": "Includes {{firstUser}} and {{secondUser}}",
  "AvatarTeam.avatarLabel": "Team Avatar",
  "AvatarUser.editAvatar": "Edit Avatar",
  "AvatarUser.unknownUserLabel": "Unknown user",
  "AvatarUser.userAvatarLabel": "User Avatar",
  "Banner.dismissButton": "Dismiss banner",
  "Breadcrumb.collapsedItems": "Collapsed Breadcrumb",
  "Breadcrumb.showPaths": "Show paths",
  "CommentRow.deactivatedLabel": "Deactivated User",
  "CommentRow.moreActions": "More Actions",
  "DateInput.spinButtonLabel": "Select a date",
  "DateInputBase.calendarButtonLabel": "Open date picker",
  "DateInputBase.closeButtonLabel": "Clear value",
  "DateInputBase.dialogLabel": "Date picker",
  "DatePicker.last7Days": "Last 7 days",
  "DatePicker.last14Days": "Last 14 days",
  "DatePicker.last30Days": "Last 30 days",
  "DatePicker.last60Days": "Last 60 days",
  "DatePicker.last90Days": "Last 90 days",
  "DatePicker.next7Days": "Next 7 days",
  "DatePicker.next14Days": "Next 14 days",
  "DatePicker.next30Days": "Next 30 days",
  "DatePicker.next60Days": "Next 60 days",
  "DatePicker.next90Days": "Next 90 days",
  "DatePicker.previous2Months": "Previous 2 months",
  "DatePicker.previous2Quarters": "Previous 2 quarters",
  "DatePicker.previous2Weeks": "Previous 2 weeks",
  "DatePicker.previous3Months": "Previous 3 months",
  "DatePicker.previous3Quarters": "Previous 3 quarters",
  "DatePicker.previous3Weeks": "Previous 3 weeks",
  "DatePicker.previous4Quarters": "Previous 4 quarters",
  "DatePicker.previous4Weeks": "Previous 4 weeks",
  "DatePicker.previous6Months": "Previous 6 months",
  "DatePicker.previous12Months": "Previous 12 months",
  "DatePicker.previousMonth": "Previous month",
  "DatePicker.previousQuarter": "Previous quarter",
  "DatePicker.previousWeek": "Previous week",
  "DatePicker.previousYear": "Previous year",
  "DatePicker.thisMonth": "This month",
  "DatePicker.thisQuarter": "This quarter",
  "DatePicker.thisWeek": "This week",
  "DatePicker.thisYear": "This year",
  "DatePicker.timezoneHoursDecrease": "Decrease timezone hours",
  "DatePicker.timezoneHoursIncrease": "Increase timezone hours",
  "DatePicker.timezoneHoursLabel": "Timezone hours",
  "DatePicker.timezoneMeridianDecrease": "Decrease timezone meridian",
  "DatePicker.timezoneMeridianIncrease": "Increase timezone meridian",
  "DatePicker.timezoneMeridianLabel": "Timezone meridian",
  "DatePicker.timezoneMinutesDecrease": "Decrease timezone minutes",
  "DatePicker.timezoneMinutesIncrease": "Increase timezone minutes",
  "DatePicker.timezoneMinutesLabel": "Timezone minutes",
  "DatePicker.today": "Today",
  "DatePicker.yearToDate": "Year to date",
  "DatePicker.yesterday": "Yesterday",
  "DateRangeInput.endButton": "Select an end date",
  "DateRangeInput.startButton": "Select a start date",
  "Ratings.defaultLegend": "Rating",
  "Ratings.label": "Rating {{ratingString}}",
  "Search.defaultPlaceholder": "Search...",
  "Search.searching": "Searching for results",
  "Search.showSearchResults": "Showing search results",
  "Tabs.removeTab": "Remove tab",
  "Tabs.scrollLeft": "Scroll left",
  "Tabs.scrollRight": "Scroll right",
  "Tag.removeTag": "Remove Tag",
  "Timestamp.defaultDateTime": "{{dateString}} at {{timeString}}",
  "Timestamp.invalidDate": "invalid date",
  "Timestamp.lessThanOneDayAgo": "{{hoursString}} hours ago",
  "Timestamp.lessThanOneHourAgo": "{{minutesString}} minutes ago",
  "Timestamp.lessThanOneMinuteAgo": "A few seconds ago",
  "Timestamp.lessThanTwoHoursAgo": "One hour ago",
  "Timestamp.lessThanTwoMinutesAgo": "One minute ago",
  "Timestamp.yesterdayAt": "Yesterday at {{timeString}}",
  "Toast.close": "Close toast",
  "Toast.destroy": "Never show this again",
  "Toast.srOnly": "notification appears",
  "Toast.titleMap.error": "Uh oh",
  "Toast.titleMap.info": "Information",
  "Toast.titleMap.success": "Success!",
  "Toast.titleMap.warning": "Warning",
  "ToastsContainer.alert": "Alert toasts live region",
  "ToastsContainer.status": "Status toasts live region",
  "TreeDynamic.error": "An error occurred",
  "TreeDynamic.loading": "Loading\u2026",
  "Uploader.downloadTemplate": "Download Template",
  "Uploader.dragAndDrop": "Drag and drop files here{{orString}}",
  "Uploader.seeLess": "See less",
  "Uploader.seeMore": "See more",
  "Uploader.upload": "upload"
};

export { enUSTranslations };
